import {
  ServicesElems as S
} from './constants';

export const NARYZHNYE = [{
  type: S.withImg,
  img: 'naryzhnye-1.jpg'
},
{
  type: S.withLine,
  text: 'Как приятно иметь загородный дом и отдыхать в нем от городского шума и суеты. И, конечно, хочется, чтобы в нем было максимально комфортно и приятно находиться, поэтому время от времени дом нужно ремонтировать как внутри, так и снаружи.'
},
{
  type: S.withTitle,
  title: "МОНТАЖ НОВОГО ФАСАДА",
  text: 'Продуманная система креплений современных фасадов упрощает процесс монтажа. Выбор материалов для наружной отделки дома велик, это может быть и декоративная штукатурка, и камень и т.д.'
},
{
  type: S.withImg,
  img: 'naryzhnye-2.jpg'
},
{
  type: S.withTitle,
  title: "ЗАМЕНА КРОВЛИ",
  text: 'С течением времени любой кровельный материал нуждается в ремонте или демонтаже. Причин может быть несколько: механические повреждения, длительный срок службы, неправильная эксплуатация и т.д. Реконструкция может быть частичная или полная замена кровли'
},
{
  type: S.withImg,
  img: 'naryzhnye-3.jpeg'
}, {
  type: S.withTitle,
  text: 'Часто замена кровли дома происходит с перепланировкой всей крыши, в ходе которой можно изменить наклон и всю форму крыши.'
}, {
  type: S.withImg,
  img: 'naryzhnye-4.jpg'
}, {
  type: S.withTitle,
  title: "УСИЛЕНИЕ / ПЕРЕДЕЛКА ФУНДАМЕНТА",
  text: 'Часто в процессе длительной эксплуатации дома может потребоваться усиление фундамента, потому что на него приходится основная нагрузка всего дома, плюс влияние оказывают природные факторы (дожди, перепады температуры, пучение почвы и т.д.). '
}, {
  type: S.withImg,
  img: 'naryzhnye-5.jpg'
}, {
  type: S.withTitle,
  title: "СОЗДАНИЕ ПРИЛЕЖАЩЕЙ К ДОМУ НОВОЙ ПОСТРОЙКИ",
  text: 'Увлекшись архитектурой дома при составлении проекта дома иногда упускается один момент – это его практичность в эксплуатации. Также может оказаться, что в ходе эксплуатации не хватает полезной площади. Такие нюансы можно решить путем строительства дополнительной постройки, прилегающей к дому.'
}, {
  type: S.withImg,
  img: 'naryzhnye-6.jpeg'
}, {
  type: S.withTitle,
  title: "УКРЕПЛЕНИЕ СТЕНОВЫХ КОНСТРУКЦИЙ",
}, {
  type: S.withList,
  title: "Если стена дома имеет значительные повреждения, то строение подлежит реконструкции. Необходимо учитывать, что трещины – это сигнал о том, что со строением что-то не так и он требует ремонта. Причинами появления дефекта в стенах могут быть следующие:",
  list: ['грунтовые воды «подмыли» фундамент, что привело к его деформации',
    'усадка фундамента – зависит от того, на какой почве построен дом',
    'ошибки и недочеты при строительстве дома (низкое качество армирования, некачественный раствор и т.д.)'
  ]
}, {
  type: S.withTitle,
  title: "СОЗДАНИЕ ТЕРРАСЫ, МАНСАРДЫ, ЕЩЕ ОДНОГО ЭТАЖА",
  text: "Увеличить площадь дома можно при помощи строительства прилежащей к дому новой постройки, а также построив еще один этаж сверху. Его можно сделать аналогичным предыдущему, или его можно сделать мансардой с интересным скошенным потолком."
}, {
  type: S.withList,
  title: "Прежде чем принять решение о строительстве еще одного этажа, нужно взвесить все за и против. Сделав экспертную оценку у специалистов, Вы сможете понять:",
  list: ['Справится ли Ваш дом с дополнительными нагрузками',
    'Какое техническое состояние перекрытий, стеновых панелей, фундамента',
    'Нужно ли укреплять всю конструкцию строения и оптимальные способы укрепления'
  ]
}, {
  type: S.withImg,
  img: 'naryzhnye-7.jpeg'
},
{
  type: S.withTitle,
  title: "ТЕПЛО-, ГИДРО-, ЗВУКО-, ПАРОИЗОЛЯЦИЯ СТЕН И КРОВЛИ",
  text: "<p>Тепло-, гидро-, звуко-, пароизоляция – это важные составляющие любых зданий. На сегодняшний день есть большое разнообразие изолирующих материалов.</p><p>Задача теплоизоляционных материалов состоит в том, чтобы уменьшить теплопередачу и поддерживать в помещении комфортную температуру. По своей структуре они могут быть неорганическими, органическими, смешанными …</p><p>Гидроизоляционные материалы защищают стены и кровлю, фундамент от влаги, природных факторов. Защищая от влаги, эти материалы продлевают срок службы всех элементов строения. </p><p>Звукоизоляция важна для комфорта и уюта в загородном доме. Необходимо делать звукоизоляцию всего помещения, но наиболее пристальное внимание нужно уделить крыше, потому что это наиболее уязвимая часть дома.</p><p>Защитным барьером, который разделяет зоны теплого и холодного воздуха, являются пароизоляционные материалы. Если их не применять, тогда перепады температуры приведут к образованию конденсата, что приведет к разрушению утеплителя и других частей строительной конструкции. Пароизоляционные материалы применяются при строительстве фасадов, перекрытий, кровли, внутренних перегородок.</p>"
}, {
  type: S.withImg,
  img: 'naryzhnye-8.jpg'
}, {
  type: S.withTitle,
  title: "ТЕПЛОИЗОЛЯЦИЯ ВЕРАНД, ТЕРРАС, БАЛКОНОВ",
  text: 'Утепление террасы частного дома – прекрасное решение, поскольку Вы сможете комфортно использовать это помещение в течение всего года. Предварительно нужно определить тип утепления, место монтажа изолятора (снаружи, внутри здания), теплоизоляционный материал и т.д. На нашем рынке есть большое количество разных видов теплоизоляционных материалов.'
}, {
  type: S.withImg,
  img: 'naryzhnye-9.jpg'
},
]